var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushLeftArrow = function SvgPushLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.057 12.667.943-.943-3.771-3.771L12 4.18l-.943-.942-4.714 4.713 4.714 4.715ZM5.105 3.333v9.334H3.77V3.333h1.334Z",
    fill: "#18BD4E"
  })));
};
export { SvgPushLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjA1NzMgMTIuNjY2N0wxMiAxMS43MjRMOC4yMjg2NyA3Ljk1MjY3TDEyIDQuMTgxMzRMMTEuMDU3MyAzLjIzODY3TDYuMzQzMzMgNy45NTJMMTEuMDU3MyAxMi42NjY3Wk01LjEwNDY3IDMuMzMzMzRMNS4xMDQ2NyAxMi42NjY3TDMuNzcxMzMgMTIuNjY2N0wzLjc3MTMzIDMuMzMzMzRMNS4xMDQ2NyAzLjMzMzM0WiIgZmlsbD0iIzE4QkQ0RSIvPgo8L3N2Zz4K";